// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"c0481fc0","453":"e7d84735"}[chunkId] + ".chunk.js";
};